import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import { Empty, Spin, Select } from 'antd';
import { Table, Tbody, Td, Th, Thead, Tr } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import Swal from "sweetalert2";
import Paging from "../../components/paging";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import Tour from "reactour";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import { pageNumber } from "../../functions/functionGeneral";
import { toast } from "react-toastify";
import { PERMISSIONS } from "../../helper/permissionHelper";
import { withPageAccess } from "../common/ProtectedPage";
import {
    Button,
    ButtonGroup,
    FormGroup,
    InputGroup,
    InputGroupAddon,
    Label,
    UncontrolledTooltip,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Col,
    Input, } from "reactstrap";
import CurrencyInput from 'react-currency-input-field';
import KOMPENSASI from "./modalKompensasi"
import POTONGAN from "./modalPotongan"
import "./style.css"
import refreshIcon from '../../assets/icons/refresh.svg'
import {IMG_HOST} from "../../helper/host";
import pencilIcon from "../../assets/icons/edit_pencil.svg"
import Switch from "react-switch";
import format from "format-number";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faTimes} from "@fortawesome/free-solid-svg-icons";
import {TourContext} from "../guideComponent/guideTourProvicer";
import {withTourGuide} from "../guideComponent/withTourGuide";

export class List_GajiKaryawan extends Component {
    static contextType = TourContext;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            jabatan: [],
            data: [],
            kompensasi: [],
            potongan: [],
            data_term: [],
            data_term_potongan: [],
            rows: [{}],
            idDel: '',
            filter_nama: "",
            filter_jabatan: "",
            karyawan_id: "",
            importFile: null,
            modalimport: false,
            modalAction: false,
            visibleKom: false,
            addDetail: false,
            visiblePot: false,
            p_term_name: "",
            p_term_type: "",
            inputType: "select",
            inputTypeKompensasi : "select",
            inputTypePotongan : "select",
            dataAction: [],
            pageCount: 0,
            currentPage: 0,
            totalData: 0,
            perPage: 0,
            paging: 25,
            guide: false,
            kom: [],
            pot: [],
            divisi:[],
            divisi_id: undefined,
            upah_lembur: '',
            upah_gaji: '',
            divisi_payroll_type: '',
            kompensasi_name: '',
            nominal_kompensasi: '',
            type_kompensasi: '',
            potongan_name: '',
            type_potongan: '',
            nominal_potongan: '',
            rows_kom: [{}],
            rows_pot: [{}],
        }
        this.handleChange = this.handleChange.bind(this)
        this.handlePageClick = this.handlePageClick.bind(this)
        this.handleFilter = this.handleFilter.bind(this)
        this.resetFilter = this.resetFilter.bind(this)
        this.handleSubmitKom = this.handleSubmitKom.bind(this)
        this.handleSubmitIstilah = this.handleSubmitIstilah.bind(this)
        this.handleSubmitAmount = this.handleSubmitAmount.bind(this)
        this.kompensasiModal = this.kompensasiModal.bind(this)
        this.loadKompensasi = this.loadKompensasi.bind(this)
        this.handleChangeStock = this.handleChangeStock.bind(this)
        this.handleChangeistilah = this.handleChangeistilah.bind(this)
        this.wantDeleteKom = this.wantDeleteKom.bind(this)
        this.addClickKom = this.addClickKom.bind(this)
        this.removeClickKom = this.removeClickKom.bind(this)
        this.handlePotonganType = this.handlePotonganType.bind(this)
        this.handlePotonganAmount = this.handlePotonganAmount.bind(this)
        this.handleSubmitPotongan = this.handleSubmitPotongan.bind(this)
        this.potonganDelete = this.potonganDelete.bind(this)
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this)
    }

    disableBody = target => disableBodyScroll(target)
    enableBody = target => enableBodyScroll(target)

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        showGuide(target, config);
    };

    handlePageClick(data) {
        let selected = data.selected; // zero based index
        this.setState({ currentPage: selected, loading: true, data: [] }, () => {
            this.loadData();
        });
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            currentPage: 0,
            [name]: value
        })
    }
    handleFilter(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;

        this.setState({
            [name]: value,
            data: [],
            loading: true
        }, () => this.loadData())
    }


    resetFilter(event) {
        this.setState({
            filter_nama: '',
            filter_jabatan: '',
            data: [],
            loading: true
        }, () => this.loadData())
    }

    handleOk = e => {
        this.setState({
            modalimport: false,
            modalAction: false
        });
    };

    handleCancel = e => {
        this.setState({
            modalimport: false,
            modalAction: false
        });
    };

    handleSubmitAmount(event, id) {
        const target = event.target;
        const name = target.name;
        var value;
        if (target.value.search(",") >= 0) {
            value = parseInt(target.value.split(',').join(''));
        } else {
            value = parseInt(target.value.split('.').join(''));
        }

        let formData = {
            karyawan_id: id,
            form: { [name]: value }
        }
        this.props.request('karyawan/payroll_update', formData, 'POST')
            .then(response => {
                if (response.success) {
                    toast['success'](response.message, { toastId: Math.floor(Math.random() * 2) })
                    this.setState({
                        loading: true,
                        editedValue: '',
                        data: [],
                    })
                    this.loadData()
                }
            });
    }

    // data kompensasi

    kompensasiModal = () => {
        this.setState({
            visibleKom: !this.state.visibleKom
        })
    };

    istillahBatal = () => {
        this.setState({
            inputType: "select",
            inputTypeKompensasi : "select",
            inputTypePotongan : "select",
            rows: [{}],
            rows_kom: [{}],
            rows_pot: [{}]
        })
    };

    handleChangeStock = (type, id) => (e, customValue, customName) => {
        const name = customName || e.target.name;
        const value = customValue || e.target.value;
        let list = [...this.state[type]];

        if (value === 'text') {
            this.setState({
                [`inputType${type === 'rows' ? '' : type === 'rows_kom' ? 'Kompensasi' : 'Potongan'}`]: value,
            });
        }

        list[id] = { ...list[id], [name]: value };

        this.setState({
            [type]: list,
        });
    };

    handleChangeistilah = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        })
    }

    handleSubmitIstilah(id) {
        this.setState({ loading: true })

        let formData = {
            p_term_type: id,
            p_term_name: this.state.p_term_name
        }
        this.props.request("payroll/add-payroll-term", formData, 'POST')
            .then((response) => {
                if (response.success) {
                    toast['success'](response.message, { toastId: Math.floor(Math.random() * 2) })
                    this.setState({
                        loading: false,
                        rows: [{}],
                        inputType: "select",
                        p_term_name: ""
                    })
                    this.loadDataTerm()
                    this.loadDataTermPotongan()
                }
                else {
                    if (Array.isArray(response.message)) {

                        response.message.map(item => {
                            toast['error'](item)
                            return true
                        })
                    } else {
                        toast['error'](response.message)
                    }
                    this.setState({ loading: false })
                }

                this.setState({ loading: false })
            })
    }

    handleSubmitKom(event, id) {
        this.setState({ loading: true })

        let formData = {
            rows: this.state.rows,
            karyawan_id: id,
        }
        this.props.request('kompensasi/add', formData, 'POST')
            .then((response) => {
                if (response.success) {
                    toast['success'](response.message, { toastId: Math.floor(Math.random() * 2) })
                    this.setState({
                        loading: false,
                        addDetail: true,
                        rows: [{}],
                    })
                    this.loadKompensasi(id)
                }
                else {
                    if (Array.isArray(response.message)) {

                        response.message.map(item => {
                            toast['error'](item)
                            return true
                        })
                    } else {
                        toast['error'](response.message)
                    }
                    this.setState({ loading: false })
                }

                this.setState({ loading: false })
            })
    }

    addClickKom() {
        this.setState({
            rows: [...this.state.rows, { k_kompensasi_type: "", p_term_id: "", k_kompensasi_amount: "" }],
            rows_kom : [...this.state.rows_kom, { k_kompensasi_type: "", p_term_id: "", k_kompensasi_amount: "" }],
        })
    }

    removeClickKom = (id) => {
        this.state.rows.splice(id, 1);
        this.state.rows_kom.splice(id, 1);
        this.setState({ rows: this.state.rows, rows_kom: this.state.rows_kom });
    };

    loadKompensasi(id) {
        let formData = {
            karyawan_id: id,

        }

        this.props.request('kompensasi/list_by_karyawan', formData, 'POST')
            .then((response) => {
                if (response.success) {
                    var result = response.data;
                    this.setState({
                        kompensasi: result.data,
                        visibleKom: true
                    })
                }
                this.setState({ isLoading: false })
            })
    }

    loadDataTerm() {
        this.setState({ loading: true })

        this.props.request("kompensasi/list-by-payroll-term", 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data_term: response.data,

                    })
                }
                this.setState({ loading: false })
            });
    }

    loadDataTermPotongan() {
        this.setState({ loading: true })

        this.props.request("karyawan_potongan/list-payroll-term", 'POST')
            .then(response => {
                if (response.success) {

                    this.setState({
                        data_term_potongan: response.data,

                    })
                }
                this.setState({ loading: false })
            });
    }

    wantDeleteKom(id, karyawan_id) {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus data kompensasi?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        isLoading: true
                    })
                    let form = {
                        id: id
                    }
                    this.props.request("kompensasi/delete", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.setState({
                                    isLoading: true
                                })
                                this.loadKompensasi(karyawan_id)
                            }
                        });
                }
            })
    }

    // data potongan

    potonganModal = () => {
        this.setState({
            visiblePot: !this.state.visiblePot
        })
    };

    loadPotongan(id) {
        this.setState({ isLoading: true })
        let form = {
            karyawan_id: id,
        }
        this.props.request("karyawan_potongan/list", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        potongan: response.data,
                        visiblePot: true
                    })
                }
                this.setState({ isLoading: false })
            });
    }

    handlePotonganType = id => (e, maskedvalue) => {

        var { name, value } = e.target;
        var list = [...this.state.potongan];

        list[id] = { ...list[id], [name]: value };

        this.setState({
            potongan: list,
        })
    };

    handlePotonganAmount = id => (e, maskedvalue) => {

        var { name, value } = e.target;
        var list = [...this.state.potongan];
        var str = maskedvalue.split('Rp ').join('');
        var final = str.split('.').join('');

        list[id] = { ...list[id], [name]: final };
        this.setState({
            potongan: list,
        })
    };

    handleChangePotongan = id => e => {

        const { name, value } = e.target;
        const list = [...this.state.potongan];

        list[id] = { ...list[id], [name]: value };

        this.setState({
            potongan: list,
        })
    };

    handleSubmitPotongan(id) {
        let formData = {
            data: this.state.potongan,
            row: this.state.rows,
            id: id,
        }
        this.props.request('karyawan_potongan/update', formData, 'POST')
            .then(response => {
                if (response.success) {
                    toast['success'](response.message, { toastId: Math.floor(Math.random() * 2) })
                    this.setState({
                        isLoading: true,
                        rows: [{
                            "p_term_id": "", "k_potongan_type": "", "k_potongan_amount": ""
                        }]
                    })
                    this.loadPotongan(id)
                }
            });
    }


    potonganDelete(id, id_pot) {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: 'Anda yakin ingin menghapus?',
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    let form = {
                        id: id_pot
                    }
                    this.props.request("karyawan_potongan/delete", form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.setState({
                                    isLoading: true,
                                })
                                this.loadPotongan(id)
                            } else {
                                Swal.fire({
                                    title: 'Gagal!',
                                    text: response.message,
                                    icon: 'warning',
                                })
                            }
                        });
                }
            })
    }

    loadData() {
        let form = {
            paginate: this.state.paging,
            page: this.state.currentPage + 1,
            filter_nama: this.state.filter_nama,
            filter_jabatan: this.state.filter_jabatan,
        }
        this.props.request("payroll/list_upah_v2", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        data: response.data.data,
                        totalData: response.data.total,
                        pageCount: response.data.last_page,
                        perPage: response.data.per_page,
                        loading: false
                    })
                }
            });
    }

    handleRowsPerPageChange = (newRowsPerPage) => {
        this.setState({ paging: newRowsPerPage }, () => {
            this.loadData();
        });
    };

    cekMasterData() {
        if (this.props.user.perusahaan.divisi === null || this.props.user.perusahaan.jabatan.length === 0 || this.props.user.perusahaan.lokasi === null) {
            Swal.fire({
                title: 'Peringatan!',
                text: 'Anda harus menambahkan Seluruh Master Data terlebih dahulu',
                icon: 'warning',
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        this.props.history.push('/karyawan/shift')
                    }
                })
        }
    }

    loadbyDivisi() {
        this.setState({
            loadingEdit: true
        })
        let form = {
            divisi_id: this.state.divisi_id,
        }
        this.props.request("payroll/list_by_divisi", form, 'POST')
            .then(response => {
                if (response.success) {
                    this.setState({
                        kom     : response.kompensasi,
                        pot     : response.potongan,
                        divisi  : response.divisi
                    })
                }
                this.setState({loadingEdit : false})
            });
    }

    batchsimpan() {
        let row_kompensasi = this.state.rows_kom.map((kompensasi, index) => ({
            [`p_term_id`]           : kompensasi.kom_p_term_id,
            [`k_kompensasi_amount`] : kompensasi.k_kompensasi_amount,
            [`k_kompensasi_type`]   : kompensasi.k_kompensasi_type
        }))
        let row_potongan = this.state.rows_pot.map((potongan, index) => ({
            [`p_term_id`]           : potongan.pot_p_term_id,
            [`k_potongan_amount`]   : potongan.k_potongan_amount,
            [`k_potongan_type`]     : potongan.k_potongan_type
        }));
        let data_pot = this.state.pot.map(potongan => ({
            k_potongan_id           : potongan.k_potongan_id,
            karyawan_id             : potongan.karyawan_id,
            p_term_id               : potongan.p_term_id,
            k_potongan_amount       : potongan.k_potongan_amount,
            k_potongan_type         : potongan.k_potongan_type,
        }));

        let form = {
            divisi_id   : this.state.divisi_id,
            upah_lembur : this.state.upah_lembur,
            upah_gaji   : this.state.upah_gaji,
            kom         : row_kompensasi,
            data_pot    : data_pot,
            pot         : row_potongan,
        }
        this.props.request("payroll/batch_edit", form, 'POST')
            .then(response => {
                if (response.success) {
                    if (response.success) {
                        Swal.fire({
                            title: 'Berhasil!',
                            text: response.message,
                            icon: 'success'
                        })
                        this.loadbyDivisi()
                        this.loadData()
                    }
                    if (response.failed) {
                        Swal.fire({
                            title: 'Gagal',
                            text: response.message,
                            icon: 'warning',
                            confirmButtonText: 'OK'
                        })
                    }
                }
            })
    }

    batchDelete(type) {
        Swal.fire({
            title: 'Pemberitahuan!',
            text: `Anda yakin ingin menghapus data ${type}?`,
            icon: 'warning',
            confirmButtonText: 'Ya',
            showCancelButton: true,
            cancelButtonText: 'Batal',
        })
            .then((result) => {
                if (result.isConfirmed) {
                    this.setState({
                        loadingEdit: true
                    })
                    let form = {
                        divisi_id   : this.state.divisi_id,
                        p_term_id   : this.state.p_term_id
                    }
                    this.props.request(`payroll/batch_delete/${type}`, form, 'POST')
                        .then(response => {
                            if (response.success) {
                                Swal.fire({
                                    title: 'Berhasil!',
                                    text: response.message,
                                    icon: 'success',
                                    showConfirmButton: false,
                                    timer: 800,
                                })
                                this.setState({
                                    loadingEdit: true
                                })
                                this.loadbyDivisi()
                            }
                        });
                }
            })
    }

    componentDidMount() {
        this.loadData()
        this.cekMasterData()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.loading === true && this.state.loading === false) {
            this.tourTimeout = setTimeout(() => {
                const tourSteps = [
                    {
                        selector: '.fltr-nama',
                        title: 'Cari Nama Karyawan',
                        content: 'Gunakan kolom pencarian ini untuk mencari data karyawan berdasarkan nama. Tekan Enter untuk memulai pencarian.'
                    },
                    {
                        selector: 'select[name="filter_jabatan"]',
                        title: 'Filter Jabatan',
                        content: 'Gunakan dropdown ini untuk memfilter daftar karyawan berdasarkan jabatan tertentu.'
                    },
                    {
                        selector: '.button-reset',
                        title: 'Reset Filter',
                        content: 'Klik tombol ini untuk mengembalikan seluruh filter ke pengaturan awal dan memuat ulang data karyawan.'
                    },
                ];

                if (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) {
                    tourSteps.push({
                        selector: '.tambah-term',
                        title: 'Batch Edit',
                        content: 'Klik tombol ini untuk mengedit data upah atau potongan beberapa karyawan sekaligus dalam satu waktu.'
                    });
                }

                if (!this.state.loading && this.state.data.length === 0) {
                    tourSteps.push({
                        selector: '.table-style',
                        title: 'Daftar Karyawan (Kosong)',
                        content: 'Belum ada data karyawan yang tersedia. Gunakan pencarian atau ubah filter untuk melihat data.'
                    });
                } else {
                    tourSteps.push(
                        {
                            selector: '.table-style',
                            title: 'Daftar Karyawan',
                            content: `Tabel ini menampilkan ${this.state.data.length} data karyawan beserta informasi upah lembur, upah gaji, kompensasi, dan potongan.`
                        }
                    );

                    if (
                        this.props.user.user_level.level_action_limited == null ||
                        this.props.user.user_level.level_action_limited.search("U") >= 0
                    ) {
                        tourSteps.push(
                            {
                                selector: 'input[name="karyawan_lembur"]',
                                title: 'Upah Lembur',
                                content: 'Masukkan nilai upah lembur per jam karyawan pada kolom ini. Tekan Enter atau klik di luar kolom untuk menyimpan perubahan.'
                            },
                            {
                                selector: 'input[name="karyawan_payroll_amount"]',
                                title: 'Upah Gaji',
                                content: 'Masukkan nilai upah gaji karyawan pada kolom ini. Tekan Enter atau klik di luar kolom untuk menyimpan perubahan.'
                            },
                            {
                                selector: `#detail-${this.state.data[0]?.karyawan_id}`,
                                title: 'Edit Kompensasi',
                                content: 'Klik tombol ini untuk melihat dan mengedit daftar kompensasi milik karyawan yang bersangkutan.'
                            },
                            {
                                selector: `#list-${this.state.data[0]?.karyawan_id}`,
                                title: 'Edit Potongan',
                                content: 'Klik tombol ini untuk melihat dan mengedit daftar potongan gaji milik karyawan yang bersangkutan.'
                            }
                        );
                    }
                }

                const { setSteps, setCurrent, setActive } = this.context;
                setSteps(tourSteps);
                setCurrent(0);
                setActive(true);
            }, 500);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tourTimeout);
    }

    render() {
        const stylefoto = {
            height: '50px',
            width: '50px',
            objectFit: 'cover',
            borderRadius: "6px"
        }
        let no = 0;
        const steps = [
            {
                selector: '.daftar-karyawan',
                content: 'Daftar Karyawan anda dapat dilihat disini',
            },
            {
                selector: '.filter-karyawan',
                content: 'Anda dapat mem-Filter daftar Karyawan anda lewat sini',
            },
        ];
        const { Option } = Select;
        return (
            <Fragment>
                <div className="body">
                <Helmet>
                    <meta charSet="utf-8" />
                    <title>Daftar Gaji Karyawan - Presensi</title>
                    <meta name="description" content="Daftar Gaji Karyawan - Presensi" />
                    </Helmet>
                        <Breadcrumb title="Daftar Gaji Karyawan" parent="Payroll"/>
                    <Tour steps={steps} isOpen={this.state.guide === true} onAfterOpen={this.disableBody} onBeforeClose={this.enableBody} onRequestClose={() => this.setState({ guide: false })} />
                        <Modal
                            style={{maxWidth: '900px', width: '100%'}}
                            isOpen={this.state.modalbedit}
                            toggle={() => this.setState({
                                modalbedit : false,
                                divisi_id: undefined
                            })}>
                            <ModalHeader toggle={() => this.setState({modalbedit: false, divisi_id: undefined})}>
                                <h3>Edit Gaji</h3>
                            </ModalHeader>
                            <ModalBody>
                                <div className="row m-2">
                                    <div className="col-md-12 mb-2">
                                        <span>Pilih Divisi</span>
                                        <div className="mt-2">
                                            <Select
                                                name="divisi_id"
                                                style={{width: '100%', borderRadius: '4px'}}
                                                value={this.props.divisi_id}
                                                placeholder="pilih divisi"
                                                allowClear
                                                filterOption={(input, option) => {
                                                    const optionChildren = option.props.children ? option.props.children.toString() : '';
                                                    const optionValue = option.props.value ? option.props.value.toString() : '';
                                                    return (
                                                        optionChildren.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                                        optionValue.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                                    );
                                                }}
                                                onChange={(value) => {
                                                    this.setState({
                                                        divisi_id: value || null,
                                                    }, () => {
                                                        this.loadbyDivisi(this.state.divisi_id);
                                                    });
                                                }}
                                                onPointerEnter={(e) => {
                                                    this.triggerGuideOnce(e, {
                                                        key: "batchEditPilihDivisi",
                                                        title: "Pilih Divisi",
                                                        content: "Pilih divisi untuk memfilter dan menampilkan data karyawan berdasarkan divisi yang dipilih."
                                                    });
                                                }}
                                            >
                                                <Option key="semua divisi" value={null}>
                                                    Semua Divisi
                                                </Option>
                                                {this.props.divisi.map((item) => (
                                                    <Option key={item.divisi_id} value={item.divisi_id}>
                                                        {item.divisi_name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                {this.state.loadingEdit ?
                                    <Spin size="large" tip="Sedang memuat data..." style={{
                                        width: '100%',
                                        margin: 'auto',
                                        marginBottom: '10px',
                                        marginTop: '10px'
                                    }} />
                                    :
                                    <div>
                                        <div className="row m-2">
                                            <div className="col-md-6">
                                                <div className="mb-2">Upah Lembur</div>
                                                <FormGroup>
                                                    <InputGroup>
                                                        <CurrencyInput
                                                            id="upah_lembur"
                                                            name="upah_lembur"
                                                            className="form-control border-radius upah-upah"
                                                            placeholder="Upah Lembur"
                                                            value={this.state.upah_lembur}
                                                            decimalSeparator=","
                                                            groupSeparator="."
                                                            prefix="Rp. "
                                                            onValueChange={(value) => {
                                                                this.setState({upah_lembur: value ? parseInt(value.replace(/\./g, '')) : 0})
                                                            }}
                                                            onBlur={() => {
                                                                if (this.state.upah_lembur === "") {
                                                                    this.setState({ upah_lembur: 0 })
                                                                }
                                                            }}
                                                            onFocus={() => {
                                                                if (this.state.upah_lembur === 0 || this.state.upah_lembur === "0") {
                                                                    this.setState({upah_lembur: ""})
                                                                }
                                                            }}
                                                            onPointerEnter={(e) => {
                                                                this.triggerGuideOnce(e, {
                                                                    key: "batchEditUpahLembur",
                                                                    title: "Upah Lembur",
                                                                    content: "Masukkan nilai upah lembur per jam untuk semua karyawan pada divisi yang dipilih."
                                                                });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="prepend">
                                                            <div className="input-group-text input-group-text-radius mobile-hide upah-upah"
                                                                 style={{ backgroundColor: "#eef1f3" }}>
                                                                <Label style={{ marginTop: '5px' }}>/Jam</Label>
                                                            </div>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                    <div className="mobile-show">
                                                        <InputGroupAddon addonType="prepend">
                                                            <div className="input-group-text input-group-text-radius upah-upah"
                                                                 style={{ backgroundColor: "#eef1f3" }}>
                                                                <Label>/Jam</Label>
                                                            </div>
                                                        </InputGroupAddon>
                                                    </div>
                                                </FormGroup>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="mb-2">Upah Gaji</div>
                                                <FormGroup>
                                                    <InputGroup>
                                                        <CurrencyInput
                                                            id="upah_gaji"
                                                            name="upah_gaji"
                                                            className="form-control border-radius upah-upah"
                                                            placeholder="Upah Gaji"
                                                            value={this.state.upah_gaji}
                                                            decimalSeparator=","
                                                            groupSeparator="."
                                                            prefix="Rp. "
                                                            onValueChange={(value) => {
                                                                this.setState({upah_gaji: value ? parseInt(value.replace(/\./g, '')) : 0})
                                                            }}
                                                            onBlur={() => {
                                                                if (this.state.upah_gaji === "") {
                                                                    this.setState({ upah_gaji: 0 })
                                                                }
                                                            }}
                                                            onFocus={() => {
                                                                if (this.state.upah_gaji === 0 || this.state.upah_gaji === "0") {
                                                                    this.setState({upah_gaji: ""})
                                                                }
                                                            }}
                                                            onPointerEnter={(e) => {
                                                                this.triggerGuideOnce(e, {
                                                                    key: "batchEditUpahGaji",
                                                                    title: "Upah Gaji",
                                                                    content: "Masukkan nilai upah gaji untuk semua karyawan pada divisi yang dipilih."
                                                                });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <div className="input-group-text mobile-hide"
                                                                 style={{height: '40px', backgroundColor: "#eef1f3"}}>
                                                                {this.state.divisi.map((item) => {
                                                                    return (
                                                                        <Label style={{marginTop: '5px'}}>/{item.divisi_payroll_type}</Label>
                                                                    )
                                                                })}
                                                            </div>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                    <div className="mobile-show">
                                                        <InputGroupAddon addonType="append">
                                                            <div className="input-group-text" style={{backgroundColor: "#eef1f3"}}>
                                                                {this.state.divisi.map((item) => {
                                                                    return (
                                                                        <Label style={{marginTop: '5px'}}>/{item.divisi_payroll_type}</Label>
                                                                    )
                                                                })}
                                                            </div>
                                                        </InputGroupAddon>
                                                    </div>
                                                </FormGroup>
                                            </div>
                                        </div>
                                        <div className="row m-2">
                                            <div className="col-md-12">
                                                <div className="mb-2">Kompensasi</div>
                                                <Row>
                                                    <Col lg="12">
                                                        {this.state.rows_kom.map((kompensasi, id) => {
                                                            return (
                                                                <Row>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            {this.state.inputTypeKompensasi == "select" ?
                                                                                <Input type="select"
                                                                                       name="kom_p_term_id"
                                                                                       value={this.state.rows_kom.p_term_id}
                                                                                       onChange={this.handleChangeStock('rows_kom', id)}
                                                                                       onPointerEnter={(e) => {
                                                                                           this.triggerGuideOnce(e, {
                                                                                               key: "batchEditKompensasiIstilah",
                                                                                               title: "Istilah Kompensasi",
                                                                                               content: "Pilih istilah kompensasi dari daftar yang tersedia, atau pilih '+ Tambah Payroll Istilah' untuk membuat istilah baru."
                                                                                           });
                                                                                       }}
                                                                                >
                                                                                    <option value="">- Daftar Istilah -</option>
                                                                                    {this.state.data_term.map((item, index) => {
                                                                                        return (
                                                                                            <option
                                                                                                key={index}
                                                                                                value={item.p_term_id}
                                                                                                selected={item.p_term_id === this.state.data_term.p_term_id}>
                                                                                                {item.p_term_name}
                                                                                            </option>
                                                                                        )
                                                                                    })}
                                                                                    <option value="text" className="text-center"
                                                                                            style={{color: "#0080ff"}}>+ Tambah Payroll Istilah
                                                                                    </option>
                                                                                </Input>
                                                                                :
                                                                                <div className="form-group">
                                                                                    <div className="input-group mb-3">
                                                                                        <input name="p_term_name"
                                                                                               style={{fontSize: "12px"}}
                                                                                               type="text"
                                                                                               onChange={this.handleChangeistilah}
                                                                                               className="form-control border-right-0"
                                                                                               id="exampleInputEmail1"
                                                                                               aria-describedby="emailHelp"
                                                                                               placeholder="Masukkan Istilah Baru"
                                                                                               autoFocus
                                                                                               onPointerEnter={(e) => {
                                                                                                   this.triggerGuideOnce(e, {
                                                                                                       key: "batchEditKompensasiIstilahBaru",
                                                                                                       title: "Tambah Istilah Baru",
                                                                                                       content: "Ketik nama istilah kompensasi baru, lalu klik 'Tambah Istilah' untuk menyimpannya, atau 'Batal' untuk membatalkan."
                                                                                                   });
                                                                                               }}
                                                                                        />
                                                                                        {this.state.p_term_name.length >= 1 ?
                                                                                            <div className="input-group-append border-left-0">
                                                                    <span className="input-group-text"
                                                                          style={{fontSize: "12px", backgroundColor: "#FFFFFF"}}
                                                                          id="basic-addon2">
                                                                        <a style={{fontSize: "12px", color: "#057CE4"}}
                                                                           onClick={(e) => this.handleSubmitIstilah("kompensasi", e)}>
                                                                            Tambah Istilah</a>
                                                                    </span>
                                                                                            </div>
                                                                                            :
                                                                                            <div className="input-group-append border-left-0">
                                                                    <span className="input-group-text"
                                                                          style={{fontSize: "12px", backgroundColor: "#FFFFFF"}}
                                                                          id="basic-addon2">
                                                                        <a style={{fontSize: "12px", color: "#057CE4"}}
                                                                           onClick={this.istillahBatal}>
                                                                            Batal
                                                                        </a>
                                                                    </span>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <select
                                                                                name="k_kompensasi_type"
                                                                                id="k_kompensasi_type"
                                                                                className="form-control text-center"
                                                                                onChange={this.handleChangeStock('rows_kom', id)}
                                                                                placeholder="tipe Kompensasi"
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditKompensasiTipe",
                                                                                        title: "Tipe Kompensasi",
                                                                                        content: "Pilih tipe kompensasi berdasarkan satuan waktu: Jam, Hari, atau Bulan."
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <option value={""}>Tipe Kompensasi</option>
                                                                                <option value="jam">Jam</option>
                                                                                <option value="hari">Hari</option>
                                                                                <option value="bulan">Bulan</option>
                                                                            </select>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <CurrencyInput
                                                                                className="form-control"
                                                                                name="k_kompensasi_amount"
                                                                                id="k_kompensasi_amount"
                                                                                placeholder="Nominal Kompensasi"
                                                                                value={kompensasi.k_potongan_amount}
                                                                                decimalsLimit={2}
                                                                                decimalSeparator=","
                                                                                groupSeparator="."
                                                                                prefix="Rp. "
                                                                                onValueChange={(value) => this.handleChangeStock('rows_kom', id)(null, value, 'k_kompensasi_amount')}
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditKompensasiNominal",
                                                                                        title: "Nominal Kompensasi",
                                                                                        content: "Masukkan nominal atau nilai kompensasi yang akan diberikan kepada karyawan."
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm="2">
                                                                        <ButtonGroup size="sm">
                                                                            <div>
                                                                                {this.state.rows_kom.length !== 1 &&
                                                                                    <Button
                                                                                        className="mb-3"
                                                                                        onClick={() => this.removeClickKom(id)}
                                                                                        color='danger'
                                                                                        onPointerEnter={(e) => {
                                                                                            this.triggerGuideOnce(e, {
                                                                                                key: "batchEditKompensasiHapusBaris",
                                                                                                title: "Hapus Baris Kompensasi",
                                                                                                content: "Klik tombol ini untuk menghapus baris kompensasi yang tidak diperlukan."
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-trash"></i>
                                                                                    </Button>}
                                                                                &nbsp;
                                                                                {this.state.rows_kom.length - 1 === id &&
                                                                                    <Button
                                                                                        onClick={this.addClickKom}
                                                                                        color="info"
                                                                                        onPointerEnter={(e) => {
                                                                                            this.triggerGuideOnce(e, {
                                                                                                key: "batchEditKompensasiTambahBaris",
                                                                                                title: "Tambah Baris Kompensasi",
                                                                                                content: "Klik tombol ini untuk menambahkan baris kompensasi baru."
                                                                                            });
                                                                                        }}
                                                                                    >
                                                                                        <i className="fa fa-plus"></i>
                                                                                    </Button>
                                                                                }
                                                                            </div>
                                                                        </ButtonGroup>
                                                                    </Col>
                                                                </Row>
                                                            );
                                                        })}
                                                    </Col>
                                                </Row>
                                                {this.state.kom.length === 0 ?
                                                    <div className="text-center" colSpan="9">
                                                        "Tidak Ada Data..."
                                                    </div> :
                                                    <Table striped className="mb-5">
                                                        <Thead>
                                                            <Tr>
                                                                <Th>Nama Kompensasi</Th>
                                                                <Th>Nominal Kompensasi</Th>
                                                                <Th>Type Kompensasi</Th>
                                                                <Th>Status</Th>
                                                                <Th>Aksi</Th>
                                                            </Tr>
                                                        </Thead>
                                                        <Tbody>
                                                            {this.state.loadingEdit &&
                                                                <Tr>
                                                                    <Td colSpan={9}>
                                                                        <Spin size="large" tip="Loading..." style={{
                                                                            width: '100%',
                                                                            margin: 'auto',
                                                                            marginBottom: '10px',
                                                                            marginTop: '10px'
                                                                        }}/>
                                                                    </Td>
                                                                </Tr>
                                                            }
                                                            {Array.from(new Set(this.state.kom.map(item => item.p_term_id))).map((p_term_id, index) => {
                                                                const item = this.state.kom.find(item => item.p_term_id === p_term_id);
                                                                return (
                                                                    <Tr>
                                                                        <Td>{item.payroll_term.p_term_name}</Td>
                                                                        <Td>{item.k_kompensasi_type}</Td>
                                                                        <Td>
                                                                            {format({
                                                                                prefix: '',
                                                                                integerSeparator: "."
                                                                            })(item.k_kompensasi_amount)}
                                                                        </Td>
                                                                        <Td>
                                                                            <Switch
                                                                                id={`detail-${item.k_kompensasi_id}`}
                                                                                name="k_kompensasi_status"
                                                                                checked={item.k_kompensasi_status === '1' ? true : false}
                                                                                onChange={(val) => {
                                                                                    this.setState({ loading: true, data: [] })
                                                                                    let formData = { id: item.k_kompensasi_id }
                                                                                    this.props.request('kompensasi/ubah_status', formData, 'POST')
                                                                                        .then((response) => {
                                                                                            if (response.success) {
                                                                                                Swal.fire({
                                                                                                    title: 'Berhasil!',
                                                                                                    text: response.message,
                                                                                                    icon: 'success',
                                                                                                    showConfirmButton: false,
                                                                                                    timer: 1500,
                                                                                                })
                                                                                            } else {
                                                                                                if (Array.isArray(response.message)) {
                                                                                                    response.message.map(item => {
                                                                                                        toast['error'](item)
                                                                                                        return true
                                                                                                    })
                                                                                                } else {
                                                                                                    toast['error'](response.message)
                                                                                                }
                                                                                            }
                                                                                            this.loadbyDivisi()
                                                                                            this.setState({ loading: false })
                                                                                        })
                                                                                }}
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditKompensasiStatus",
                                                                                        title: "Status Kompensasi",
                                                                                        content: "Aktifkan atau nonaktifkan kompensasi ini menggunakan tombol toggle. Biru berarti aktif, merah berarti nonaktif."
                                                                                    });
                                                                                }}
                                                                                onColor="#1890ff"
                                                                                offColor="#eb4034"
                                                                                handleDiameter={16}
                                                                                uncheckedIcon={
                                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 3, color: "white", paddingRight: -5 }}>
                                                                                        <FontAwesomeIcon icon={faTimes} style={{fontSize: 15}}/>
                                                                                    </div>
                                                                                }
                                                                                checkedIcon={
                                                                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%", fontSize: 4, color: "white", paddingLeft: 3 }}>
                                                                                        <FontAwesomeIcon icon={faCheck} style={{fontSize: 15}}/>
                                                                                    </div>
                                                                                }
                                                                                boxShadow="0px 1px 1px rgba(0, 0, 0, 0.6)"
                                                                                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                                                                height={18}
                                                                                width={40}
                                                                                className="mr-1"
                                                                            />
                                                                        </Td>
                                                                        <Td>
                                                                            <a onClick={() => {
                                                                                this.setState({ p_term_id: item.p_term_id }, () => {
                                                                                    this.batchDelete('Kompensasi')
                                                                                })
                                                                            }}
                                                                               onPointerEnter={(e) => {
                                                                                   this.triggerGuideOnce(e, {
                                                                                       key: "batchEditKompensasiHapus",
                                                                                       title: "Hapus Kompensasi",
                                                                                       content: "Klik ikon ini untuk menghapus data kompensasi karyawan yang sudah tersimpan."
                                                                                   });
                                                                               }}
                                                                            >
                                                                                <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(255 37 37)' }}></i>
                                                                            </a>
                                                                        </Td>
                                                                    </Tr>
                                                                )
                                                            })}
                                                        </Tbody>
                                                    </Table>
                                                }
                                            </div>
                                        </div>
                                        <div className="ml-2">
                                            <div className="mb-2 ml-3">Potongan</div>
                                            <Col lg="12">
                                                {Array.from(new Set(this.state.pot.map(item => item.p_term_id)))
                                                    .map((p_term_id, id) => {
                                                        const item = this.state.pot.find(item => item.p_term_id === p_term_id);
                                                        const index = this.state.pot.findIndex(item => item.p_term_id === p_term_id);
                                                        return (
                                                            <Row key={p_term_id}>
                                                                <Col className="text-center" name="p_term_id" value={item.p_term_id}>
                                                                    {item.payroll_term?.p_term_name}
                                                                </Col>
                                                                <Col>
                                                                    <FormGroup>
                                                                        <select
                                                                            name="k_potongan_type"
                                                                            id="k_potongan_type"
                                                                            className="form-control"
                                                                            onChange={(e) => {
                                                                                const updatedPot = this.state.pot.map(potItem => {
                                                                                    if (potItem.p_term_id === p_term_id) {
                                                                                        return { ...potItem, k_potongan_type: e.target.value };
                                                                                    }
                                                                                    return potItem;
                                                                                });
                                                                                this.setState({pot: updatedPot});
                                                                            }}
                                                                            placeholder="Tipe Potongan"
                                                                            value={item.k_potongan_type !== null ? item.k_potongan_type : ""}
                                                                            onPointerEnter={(e) => {
                                                                                this.triggerGuideOnce(e, {
                                                                                    key: "batchEditPotonganTipe",
                                                                                    title: "Tipe Potongan",
                                                                                    content: "Pilih tipe potongan berdasarkan satuan waktu: Jam, Hari, atau Bulan."
                                                                                });
                                                                            }}
                                                                        >
                                                                            <option value={""}>Tipe Potongan</option>
                                                                            <option value="jam">Jam</option>
                                                                            <option value="hari">Hari</option>
                                                                            <option value="bulan">Bulan</option>
                                                                        </select>
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col>
                                                                    <FormGroup>
                                                                        <CurrencyInput
                                                                            id="k_potongan_amount"
                                                                            name="k_potongan_amount"
                                                                            className="form-control"
                                                                            placeholder="Nominal Potongan"
                                                                            value={item.k_potongan_amount !== null ? item.k_potongan_amount : ""}
                                                                            decimalSeparator=","
                                                                            defaultValue={item.k_potongan_amount}
                                                                            groupSeparator="."
                                                                            prefix="Rp. "
                                                                            onValueChange={(value) => {
                                                                                const finalValue = value ? parseInt(value.replace(/\./g, '')) : 0;
                                                                                const updatedPot = this.state.pot.map(potItem => {
                                                                                    if (potItem.p_term_id === p_term_id) {
                                                                                        return { ...potItem, k_potongan_amount: finalValue };
                                                                                    }
                                                                                    return potItem;
                                                                                });
                                                                                this.setState({pot: updatedPot});
                                                                            }}
                                                                            onBlur={() => {
                                                                                if (!item.k_potongan_amount) {
                                                                                    let updatedPot = [...this.state.pot];
                                                                                    updatedPot[index] = { ...updatedPot[index], k_potongan_amount: 0 };
                                                                                    this.setState({pot: updatedPot});
                                                                                }
                                                                            }}
                                                                            onFocus={() => {
                                                                                if (item.k_potongan_amount === 0) {
                                                                                    let updatedPot = [...this.state.pot];
                                                                                    updatedPot[index] = { ...updatedPot[index], k_potongan_amount: 0 };
                                                                                    this.setState({pot: updatedPot});
                                                                                }
                                                                            }}
                                                                            onPointerEnter={(e) => {
                                                                                this.triggerGuideOnce(e, {
                                                                                    key: "batchEditPotonganNominal",
                                                                                    title: "Nominal Potongan",
                                                                                    content: "Masukkan nominal potongan yang akan dipotong dari gaji karyawan."
                                                                                });
                                                                            }}
                                                                        />
                                                                    </FormGroup>
                                                                </Col>
                                                                <Col sm="2">
                                                                    {item.payroll_term.p_term_prefix === "general" ? (
                                                                        <ButtonGroup size="sm">
                                                                            <Button
                                                                                className="mt-1"
                                                                                onClick={() => {
                                                                                    this.setState({ p_term_id: item.p_term_id }, () => {
                                                                                        this.batchDelete('Potongan')
                                                                                    })
                                                                                }}
                                                                                color="danger"
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditPotonganHapus",
                                                                                        title: "Hapus Potongan",
                                                                                        content: "Klik tombol ini untuk menghapus data potongan karyawan yang sudah tersimpan."
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <i className="fa fa-trash"></i>
                                                                            </Button>
                                                                        </ButtonGroup>
                                                                    ) : ""}
                                                                </Col>
                                                            </Row>
                                                        )
                                                    })
                                                }
                                                <Row>
                                                    <Col lg="12">
                                                        {this.state.rows_pot.map((potongan, id) => {
                                                            return (
                                                                <Row className="row-md-12">
                                                                    <Col>
                                                                        <FormGroup>
                                                                            {this.state.inputTypePotongan == "select" ?
                                                                                <Input type="select"
                                                                                       name="pot_p_term_id"
                                                                                       value={potongan.p_term_id}
                                                                                       onChange={this.handleChangeStock('rows_pot', id)}
                                                                                       onPointerEnter={(e) => {
                                                                                           this.triggerGuideOnce(e, {
                                                                                               key: "batchEditPotonganIstilah",
                                                                                               title: "Istilah Potongan",
                                                                                               content: "Pilih istilah potongan dari daftar yang tersedia, atau pilih '+ Tambah Payroll Istilah' untuk membuat istilah baru."
                                                                                           });
                                                                                       }}
                                                                                >
                                                                                    <option value="">- Daftar Istilah -</option>
                                                                                    {this.state.data_term_potongan.map((item, index) => {
                                                                                        return (
                                                                                            <option
                                                                                                key={index}
                                                                                                value={item.p_term_id}
                                                                                                selected={item.p_term_id === this.state.data_term_potongan.p_term_id}>
                                                                                                {item.p_term_name}
                                                                                            </option>
                                                                                        )
                                                                                    })}
                                                                                    <option value="text" className="text-center"
                                                                                            style={{color: "#0080ff"}}>+ Tambah Payroll Istilah
                                                                                    </option>
                                                                                </Input>
                                                                                :
                                                                                <div className="form-group">
                                                                                    <div className="input-group mb-3">
                                                                                        <input name="p_term_name"
                                                                                               style={{fontSize: "12px"}}
                                                                                               type="text"
                                                                                               onChange={this.handleChangeistilah}
                                                                                               className="form-control border-right-0"
                                                                                               id="exampleInputEmail1"
                                                                                               aria-describedby="emailHelp"
                                                                                               placeholder="Masukkan Istilah Baru"
                                                                                               autoFocus
                                                                                               onPointerEnter={(e) => {
                                                                                                   this.triggerGuideOnce(e, {
                                                                                                       key: "batchEditPotonganIstilahBaru",
                                                                                                       title: "Tambah Istilah Potongan Baru",
                                                                                                       content: "Ketik nama istilah potongan baru, lalu klik 'Tambah Istilah' untuk menyimpannya, atau 'Batal' untuk membatalkan."
                                                                                                   });
                                                                                               }}
                                                                                        />
                                                                                        {this.state.p_term_name.length >= 1 ?
                                                                                            <div className="input-group-append border-left-0">
                                                                    <span className="input-group-text"
                                                                          style={{fontSize: "12px", backgroundColor: "#FFFFFF"}}
                                                                          id="basic-addon2">
                                                                        <a style={{fontSize: "12px", color: "#057CE4"}}
                                                                           onClick={(e) => this.handleSubmitIstilah("potongan", e)}>Tambah Istilah</a>
                                                                    </span>
                                                                                            </div>
                                                                                            :
                                                                                            <div className="input-group-append border-left-0">
                                                                    <span className="input-group-text"
                                                                          style={{fontSize: "12px", backgroundColor: "#FFFFFF"}}
                                                                          id="basic-addon2">
                                                                        <a style={{fontSize: "12px", color: "#057CE4"}}
                                                                           onClick={this.istillahBatal}>Batal</a>
                                                                    </span>
                                                                                            </div>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            }
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <select
                                                                                name="k_potongan_type"
                                                                                id="k_potongan_type"
                                                                                className="form-control"
                                                                                onChange={this.handleChangeStock('rows_pot', id)}
                                                                                value={potongan.k_potongan_type}
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditPotonganBaruTipe",
                                                                                        title: "Tipe Potongan Baru",
                                                                                        content: "Pilih tipe potongan baru berdasarkan satuan waktu: Jam, Hari, atau Bulan."
                                                                                    });
                                                                                }}
                                                                            >
                                                                                <option value={""}>Tipe Potongan</option>
                                                                                <option value="jam">Jam</option>
                                                                                <option value="hari">Hari</option>
                                                                                <option value="bulan">Bulan</option>
                                                                            </select>
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col>
                                                                        <FormGroup>
                                                                            <CurrencyInput
                                                                                className="form-control"
                                                                                name="k_potongan_amount"
                                                                                id="k_potongan_amount"
                                                                                placeholder="Nominal Potongan"
                                                                                value={potongan.k_potongan_amount}
                                                                                decimalsLimit={2}
                                                                                decimalSeparator=","
                                                                                groupSeparator="."
                                                                                prefix="Rp. "
                                                                                onValueChange={(value) => this.handleChangeStock('rows_pot', id)(null, value, 'k_potongan_amount')}
                                                                                onPointerEnter={(e) => {
                                                                                    this.triggerGuideOnce(e, {
                                                                                        key: "batchEditPotonganBaruNominal",
                                                                                        title: "Nominal Potongan Baru",
                                                                                        content: "Masukkan nominal potongan baru yang akan diterapkan pada karyawan."
                                                                                    });
                                                                                }}
                                                                            />
                                                                        </FormGroup>
                                                                    </Col>
                                                                    <Col sm="2"></Col>
                                                                </Row>
                                                            )
                                                        })}
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </div>
                                    </div>
                                }
                            </ModalBody>
                            <ModalFooter>
                                <div className="mr-2">
                                    <button className="btn btn-primary" onClick={() => {
                                        this.batchsimpan()
                                    }}>Simpan</button>
                                </div>
                            </ModalFooter>
                        </Modal>
                        <div className="container-fluid list-karyawan rounded">
                            <div className="card border border-secondary-subtle">
                                <div className="card-header pb-0">
                                    <div className="row mx-0">
                                        <div className="col-md-4 px-1">
                                            <input name="filter_nama"
                                                   className="form-control fltr-nama mb-2 input-select-style mt-0"
                                                   placeholder="&#xF002;  Nama Karyawan..."
                                                   type="text"
                                                   value={this.state.filter_nama}
                                                   onChange={this.handleChange}
                                                   onKeyUp={(event) => {
                                                       event.preventDefault()
                                                       if (event.which == 13) {

                                                           this.setState({
                                                               page: 0,
                                                               paging: this.state.paging,
                                                               loading: true
                                                           }, () => {
                                                               this.loadData()
                                                           });
                                                       }
                                                   }}/>
                                        </div>
                                        <div className="col-md-4 px-1 d-flex flex-row flex-nowrap mb-2">
                                            <select name="filter_jabatan" value={this.state.filter_jabatan}
                                                    className="form-control input-select-style select-column w-100 m-0"
                                                    style={{fontSize: "12px", marginRight: "5px"}}
                                                    onChange={this.handleFilter}>
                                                <option value="">Pilih Jabatan</option>
                                                {this.props.jabatan.map((item, index) => {
                                                    return (
                                                        <option value={item.jabatan_id}>{item.jabatan_nama}</option>
                                                    )
                                                })}
                                            </select>
                                            <div>
                                                <button className="input-select-style button-reset mt-0 ml-2"
                                                        style={{width: "44px"}}
                                                        onClick={this.resetFilter}><img src={refreshIcon} alt=""/>
                                                </button>
                                            </div>
                                        </div>
                                        <div className="col-md-4 px-1">
                                            <button className="btn btn-primary tambah-term"
                                                    onClick={() => this.setState({modalbedit: true}, () => {
                                                        this.loadbyDivisi()
                                                        this.loadDataTerm()
                                                        this.loadDataTermPotongan()
                                                    })}><img src={pencilIcon}/> Batch Edit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <hr style={{marginTop: '8px', marginBottom: "8px"}}/>
                                <div className="card-body daftar-karyawan pt-0">
                                    {!this.state.loading && this.state.data.length === 0 ?
                                        <Empty description="Data Kosong"
                                               image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"/>
                                        :
                                        (this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("R") >= 0) && (
                                            <Table className="mb-5 table-style">
                                        <Thead>
                                            <Tr className="thead-tr">
                                                <Th width="30">#</Th>
                                                <Th className="text-left" width="90"><span style={{ fontSize: 12 }}>Foto</span></Th>
                                                <Th className="text-left" width="200"><span style={{ fontSize: 12 }}>Nama Karyawan</span></Th>
                                                <Th className="text-left" width="180"><span style={{ fontSize: 12 }}>Jabatan-Divisi</span></Th>
                                                <Th className="text-left" width="200"><span style={{ fontSize: 12 }}>Upah Lembur</span></Th>
                                                <Th className="text-left" width="200"><span style={{ fontSize: 12 }}>Upah Gaji</span></Th>
                                                <Th className="text-left" width="100"><span style={{ fontSize: 12 }}>Kompensasi</span></Th>
                                                <Th className="text-left" width="100"><span style={{ fontSize: 12 }}>Potongan</span></Th>
                                            </Tr>
                                        </Thead>
                                            <br/>
                                        <Tbody className="tbody-table">
                                            {this.state.loading &&
                                                <Tr>
                                                    <Td colSpan={10}>
                                                        <Spin size="large" tip="Loading..." style={{
                                                            width: '100%',
                                                            margin: 'auto',
                                                            marginBottom: '10px',
                                                            marginTop: '10px'
                                                        }} />
                                                    </Td>
                                                </Tr>
                                            }
                                            {this.state.data.map((item, index) => {
                                                no += 1
                                                return (
                                                    <Tr className="table-tr">
                                                        <Th className="number-list" scope="row">{pageNumber(no, this.state.perPage, this.state.currentPage)}</Th>
                                                        <Td style={{ border: "none" }}>{item.karyawan_foto !== null ? (
                                                            <img style={stylefoto} alt=''
                                                                 src={IMG_HOST + 'frontapp/karyawan/' + item.karyawan_foto} />
                                                        ) : (
                                                            <img style={stylefoto} alt=''
                                                                 src={IMG_HOST + "user-profile.png"} />
                                                        )}</Td>
                                                        <Td align="left">
                                                            <span style={{ fontWeight: 600 }}>{item.karyawan_nama}</span><br/>
                                                            <p style={{ fontWeight: 300 }}>{item.karyawan_email}</p>
                                                        </Td>
                                                        <Td align="left">
                                                            <span style={{ fontWeight: 600 }}>{item && item.jabatan && item.jabatan.jabatan_nama}</span>
                                                            <p style={{ fontWeight: 300 }}>{item.divisi.divisi_name}</p>
                                                        </Td>
                                                        {/* upah lembur */}
                                                        <Td className="text-start">
                                                            <div style={{ padding: 4 }} className="input-column">
                                                                <FormGroup>
                                                                    <InputGroup>
                                                                        <CurrencyInput
                                                                            name="karyawan_lembur"
                                                                            decimalSeparator={','}
                                                                            groupSeparator="."
                                                                            className="form-control border-radius upah-upah"
                                                                            disabled={!(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0)}
                                                                            value={item.karyawan_lembur}
                                                                            id="karyawan_lembur"
                                                                            onKeyPress={(event) => {
                                                                                if (event.which == 13) {
                                                                                    event.preventDefault()
                                                                                    this.handleSubmitAmount(event, item.karyawan_id)
                                                                                }
                                                                            }}
                                                                            onBlur={(event) => {
                                                                                this.handleSubmitAmount(event, item.karyawan_id)
                                                                            }}
                                                                            onValueChange={(value, name) => {
                                                                                let newData = this.state.data
                                                                                newData[index].karyawan_lembur = value
                                                                                this.setState({
                                                                                    editedValue: value,
                                                                                    data: newData
                                                                                })
                                                                            }}
                                                                        />
                                                                        <InputGroupAddon addonType="prepend">
                                                                            <div className="input-group-text input-group-text-radius mobile-hide upah-upah"
                                                                                style={{ backgroundColor: "#eef1f3" }}>
                                                                                <Label
                                                                                    style={{ marginTop: '5px' }}>/Jam
                                                                                </Label>
                                                                            </div>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                    <div className="mobile-show">
                                                                        <InputGroupAddon addonType="prepend">
                                                                            <div className="input-group-text input-group-text-radius upah-upah"
                                                                                style={{ backgroundColor: "#eef1f3" }}>
                                                                                <Label>/Jam</Label>
                                                                            </div>
                                                                        </InputGroupAddon>
                                                                    </div>
                                                                </FormGroup>
                                                            </div>
                                                        </Td>
                                                        {/* upah gaji */}
                                                        <Td className="text-start">
                                                            <div style={{ padding: 4 }} className="input-column">
                                                                <FormGroup>
                                                                    <InputGroup>
                                                                        <CurrencyInput
                                                                            name="karyawan_payroll_amount"
                                                                            className="form-control border-radius upah-upah"
                                                                            decimalSeparator={','}
                                                                            groupSeparator="."
                                                                            disabled={!(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0)}
                                                                            value={item.karyawan_payroll_amount}
                                                                            id="karyawan_payroll_amount"
                                                                            onKeyPress={(event) => {
                                                                                if (event.which == 13) {
                                                                                    event.preventDefault()
                                                                                    this.handleSubmitAmount(event, item.karyawan_id)
                                                                                }
                                                                            }}
                                                                            onBlur={(event) => {
                                                                                this.handleSubmitAmount(event, item.karyawan_id)
                                                                            }}
                                                                            onValueChange={(value, name) => {
                                                                                let newData = this.state.data
                                                                                newData[index].karyawan_payroll_amount = value
                                                                                this.setState({
                                                                                    editedValue: value,
                                                                                    data: newData
                                                                                })
                                                                            }}
                                                                        />
                                                                        <InputGroupAddon addonType="prepend">
                                                                            <div className="input-group-text input-group-text-radius mobile-hide upah-upah"
                                                                                style={{ backgroundColor: "#eef1f3" }}>
                                                                                <Label>/{item.divisi.divisi_payroll_type}
                                                                                </Label>
                                                                            </div>
                                                                        </InputGroupAddon>
                                                                    </InputGroup>
                                                                    <div className="mobile-show">
                                                                        <InputGroupAddon addonType="prepend">
                                                                            <div className="input-group-text input-group-text-radius upah-upah"
                                                                                style={{ backgroundColor: "#eef1f3" }}>
                                                                                <Label>/{item.divisi.divisi_payroll_type}</Label>
                                                                            </div>
                                                                        </InputGroupAddon>
                                                                    </div>
                                                                </FormGroup>
                                                            </div>
                                                        </Td>
                                                        <Td align="center">
                                                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                                                <>
                                                                    <Button id={`detail-${item.karyawan_id}`}
                                                                            className="btn-shadow button-style-edit"
                                                                            style={{ width: "77px", paddingLeft:"5px" }}
                                                                            color="primary"
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    karyawan_id: item.karyawan_id,
                                                                                }, () => {
                                                                                    this.loadKompensasi(item.karyawan_id)
                                                                                    this.loadDataTerm()
                                                                                })
                                                                            }}
                                                                    ><img src={pencilIcon} /> Edit</Button>&nbsp;
                                                                    <UncontrolledTooltip placement="top"
                                                                                         target={`detail-${item.karyawan_id}`}>
                                                                        List Kompensasi
                                                                    </UncontrolledTooltip>
                                                                </>
                                                            )}
                                                        </Td>
                                                        <Td align="center">
                                                            {(this.props.user.user_level.level_action_limited == null || this.props.user.user_level.level_action_limited.search("U") >= 0) && (
                                                                <>
                                                                    <Button id={`list-${item.karyawan_id}`}
                                                                            className="btn-shadow button-style-edit"
                                                                            style={{ width: "77px", paddingLeft:"5px" }}
                                                                            color="primary"
                                                                            onClick={() => {
                                                                                this.setState({
                                                                                    karyawan_id: item.karyawan_id
                                                                                }, () => {
                                                                                    this.loadPotongan(item.karyawan_id)
                                                                                    this.loadDataTermPotongan()
                                                                                })
                                                                            }}
                                                                    ><img src={pencilIcon} /> Edit</Button>&nbsp;
                                                                    <UncontrolledTooltip placement="top"
                                                                                         target={`list-${item.karyawan_id}`}>
                                                                        List Potongan
                                                                    </UncontrolledTooltip>
                                                                </>
                                                            )}
                                                        </Td>
                                                    </Tr>
                                                )
                                            })}
                                        </Tbody>
                                    </Table>
                                    )
                                }
                                <div className='col font-14' style={{ padding: "auto", margin: "auto", fontWeight: 500, lineHeight: "24px" }}>
                                    menampilkan {this.state.data.length === 0 || this.state.data.length === null ? "0" : this.state.data.length} dari {this.state.totalData} data, Tampilkan
                                    <button className='button border px-1 ml-1' onClick={() => this.handleRowsPerPageChange(25)}>25</button>
                                    <button className='button border px-1 ml-1' onClick={() => this.handleRowsPerPageChange(50)}>50</button>
                                    <button className='button border px-1 ml-1' onClick={() => this.handleRowsPerPageChange(100)}>100</button>
                                </div>
                                <Paging
                                    className="float-right"
                                    handlePageClick={this.handlePageClick}
                                    pageCount={this.state.pageCount}
                                    currentPage={this.state.currentPage}
                                />
                            </div>
                        </div>
                    </div>
                    <KOMPENSASI
                        kompensasi={this.state.kompensasi}
                        id={this.state.karyawan_id}
                        visibleKom={this.state.visibleKom}
                        dataTerm={this.state.data_term}
                        rows={this.state.rows}
                        addClickKom={this.addClickKom}
                        handleSubmitKom={this.handleSubmitKom}
                        removeClickKom={this.removeClickKom}
                        handleChangeStock={this.handleChangeStock}
                        handleChangeistilah={this.handleChangeistilah}
                        wantDeleteKom={this.wantDeleteKom}
                        kompensasiModal={this.kompensasiModal}
                        loadKompensasi={this.loadKompensasi}
                        request={this.props.request}
                        loading={this.state.loading}
                        inputType={this.state.inputType}
                        p_term_name={this.state.p_term_name}
                        handleSubmitIstilah={this.handleSubmitIstilah}
                        istillahBatal={this.istillahBatal}
                        changeState={(event) => {
                            this.setState(event)
                        }}

                    />
                    <POTONGAN
                        potongan={this.state.potongan}
                        visiblePot={this.state.visiblePot}
                        id={this.state.karyawan_id}
                        rows={this.state.rows}
                        dataTermPotongan={this.state.data_term_potongan}
                        handleChangeStock={this.handleChangeStock}
                        potonganModal={this.potonganModal}
                        handlePotonganType={this.handlePotonganType}
                        handlePotonganAmount={this.handleChangePotongan}
                        handleSubmitPotongan={this.handleSubmitPotongan}
                        handleSubmitIstilah={this.handleSubmitIstilah}
                        istillahBatal={this.istillahBatal}
                        inputType={this.state.inputType}
                        p_term_name={this.state.p_term_name}
                        removeClick={this.potonganDelete}
                        handleChangeistilah={this.handleChangeistilah}
                        changeState={(event) => {
                            this.setState(event)
                        }}
                    />
                    </div>
                </Fragment>
            );
    }
}

const mapStateToProps = state => ({
    user: state.Auth.user,
    jabatan: state.Filter._jabatan,
    divisi: state.Filter._divisi
})

export default connect(mapStateToProps)(withPageAccess(withTourGuide(List_GajiKaryawan), PERMISSIONS.DAFTAR_GAJI_KARYAWAN));
